/*
 * @Author: lc 2631402207@qq.com
 * @Date: 2025-11-11 15:45:23
 * @LastEditors: lc 2631402207@qq.com
 * @LastEditTime: 2025-11-11 20:42:49
 * @FilePath: \senlan-ai-ui\src\stores\online.store.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { atom } from 'jotai'

// 抽屉是否打开
export const isOnlineOpenAtom = atom(false)

export const onlineDataAtom = atom<any>([])

// 开关控制
export const openOnlineAtom = atom(null, (get, set, data?: any) => {
  set(isOnlineOpenAtom, true)
})

export const closeOnlineAtom = atom(null, (get, set) => {
  set(isOnlineOpenAtom, false)
  set(onlineDataAtom, null)
})
export const updateOnlineDataAtom = atom(null, (get, set, partial: any) => {
  set(onlineDataAtom, [...partial])
})
